import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "../types";

const initialState: Notification[] = [];

export const NotificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    onNotifications: (state, action: PayloadAction<Notification[]>) => {
      const newState = [...state];
      for (let item of action.payload) {
        const index = newState.findIndex((i) => i.uid === item.uid);
        if (index === -1) {
          newState.push(item);
        } else {
          newState[index] = item;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onNotificationsDeleted: (state, action: PayloadAction<string[]>) => {
      const ids = new Set(action.payload);
      return state.filter((n) => !ids.has(n.uid));
    },
  },
});

export const { onNotifications, onNotificationsDeleted } =
  NotificationSlice.actions;
